import {
  getLocalStorageWithExpiry,
  removeItemFromLocalStorage,
  setLocalStorageWithExpiry,
} from "@redotech/redo-web/utils/local-storage-wrapper";

/**
 * localStorage marker that records when a merchant arrived from a TOFU
 * intent-only ad. The /intent landing page writes the marker before
 * bouncing to the Shopify App Store; the onboarding completion handler
 * reads it to redirect the merchant to /conversion/intent-setup after
 * install + first-install onboarding.
 *
 * Key facts:
 * - Same origin throughout the Shopify install round-trip
 *   (app.getredo.com is top-level, no App Bridge / iframe), so the
 *   marker survives the OAuth handshake.
 * - 14-day TTL guards against the case where a merchant clicks the
 *   ad, never installs, then installs from a different entry point
 *   months later — we don't want to misroute them.
 * - Uses the shared local-storage-wrapper which centralizes try/catch,
 *   JSON encoding, and expiry handling.
 */

const LOCAL_STORAGE_KEY = "redo.intent-ad-marker";
const TTL_HOURS = 14 * 24;

export function setIntentMarker(): void {
  setLocalStorageWithExpiry(LOCAL_STORAGE_KEY, true, TTL_HOURS);
}

export function readIntentMarker(): boolean {
  return getLocalStorageWithExpiry(LOCAL_STORAGE_KEY) === true;
}

export function clearIntentMarker(): void {
  removeItemFromLocalStorage(LOCAL_STORAGE_KEY);
}
